export const CERTIFICATE_NAME_FIELD = 'name';
export const CERTIFICATE_USAGE_FIELD = 'certificateUsage';
export const CERTIFICATE_DESCRIPTION_FIELD = 'description';
export const CERTIFICATE_ASSOCIATION_FIELD = 'associationType';
export const CERTIFICATE_PRIVATE_KEY_FIELD = 'privateKey';
export const CERTIFICATE_FIELD = 'certificate';
export const PRIVATE_KEY_VALUE_FIELD = 'privateKey.value';
export const PRIVATE_KEY_PASS_FIELD = 'privateKeyPassphrase.value';
export const TAB_CERTIFICATES = 'certificates';
export const TAB_TRUSTED = 'trusted';

export const CERTIFICATE_USAGES = {
    wifi: 'Wi-Fi',
    wired: 'Ethernet',
    voip: 'VoIP',
    web: 'Web',
};
export const ASSOCIATION_TYPE = {
    shared: 'Shared',
    device: 'Device',
};

export const CERTIFICATE_IN_USE_ERRORS = {
    WIFI: 'wifi_certificate_in_use',
    WIRED: 'wired_certificate_in_use',
    WEB: 'web_certificate_in_use',
};

export const CERTIFICATE_DATA_SOURCE = {
    url: '/query/admin/nPointCertificate',
    crudUrl: '/ipm/v1/admin/nPointCertificate/',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: [CERTIFICATE_NAME_FIELD, CERTIFICATE_USAGE_FIELD, CERTIFICATE_DESCRIPTION_FIELD],
        excludeIncompleteCerts: true,
    },
};

export const TRUSTED_DATA_SOURCE = {
    url: '/query/admin/trustedCACertificate',
    crudUrl: '/ipm/v1/admin/trustedCACertificate/',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: [CERTIFICATE_NAME_FIELD, CERTIFICATE_DESCRIPTION_FIELD],
    },
};
